module.exports = __webpack_public_path__ + "static/media/range_3_blue.01b2d73f.png";